import {useMemo} from 'react';
import {useTheme} from '@mui/material';
import type {PreviewConfiguration} from 'schema/types';
import {Preview} from 'schema/preview';
import {usePreviewConfigurationContextProviderValue} from 'schema/preview/contexts';
import type {ReadonlyExpressionCardProps} from './types';

export const ReadonlyExpressionCard: React.FC<ReadonlyExpressionCardProps> = ({
  expression,
  schema,
  configuration,
}) => {
  const {colors} = useTheme();
  const expressionPreviewConfiguration =
    useMemo((): Partial<PreviewConfiguration> => {
      return {
        nameVariant: {
          excludeMainForm: false,
        },
        layout: {
          noLabels: true,
          noGrid: true,
          partSpacing: 1,
          linkedValuesByRoles: true,
          groups: {},
          ...(configuration?.layout ?? {}),
        },
        rootContainer: 'NoContainer',
        schemaContainers: {
          expression: 'NoContainer',
        },
        text: {
          label: {
            variant: 'caption',
            sx: {
              color: colors.warmGreen,
            },
          },
          value: {
            variant: 'caption',
            sx: {
              color: colors.warmGreen,
            },
          },
        },
        excludeParts: ['languages', 'expressionFormat'],
        linking: configuration?.linking,
        onNavigate: configuration?.onNavigate,
      };
    }, [configuration, colors]);

  const previewConfiguration = usePreviewConfigurationContextProviderValue(
    expressionPreviewConfiguration,
  );

  return (
    <Preview
      schema={schema}
      data={expression}
      configuration={previewConfiguration}
    />
  );
};
